import ActionHelper from '@module/redux-actions';
import TermsAndConditions from '@module/terms-and-conditions';
import Analytics from '@module/analytics';
import LaunchDarkly from '@module/launchdarkly';

export const actions = ActionHelper.types([
  'LANGUAGE_SET',
  'REDIRECT_SET',
  'REDIRECT_CLEAR',
  'REQUIRE_REFRESH',
  'ACCEPT_TERMS_CONDITIONS',

  'SET_DOMAIN_USER_ID',
]);

export default ActionHelper.generate({
  setRedirect: [actions.REDIRECT_SET, 'path'],
  clearRedirect: [actions.REDIRECT_CLEAR],
  requireRefresh: [actions.REQUIRE_REFRESH],

  setLanguage(language) {
    // FIXME: I shouldn't be here
    Analytics.trackGoogleEvent({
      category: 'Language',
      action: 'Change',
      label: language,
      user: { language },
    });
    return { type: actions.LANGUAGE_SET, language };
  },

  acceptTermsConditions() {
    TermsAndConditions.accept();

    Analytics.trackFirstVisit();

    LaunchDarkly.boot();
    return { type: actions.ACCEPT_TERMS_CONDITIONS };
  },

  setDomainUserId: [actions.SET_DOMAIN_USER_ID, 'id'],
});
